import styled from 'styled-components'

export const BtnsWrapper = styled.div`
	text-align: center;
`

export const ErrorsWrapper = styled.div`
	color: ${({ theme }) => theme.errorColor};
	font-size: 11px;
	svg {
		margin-right: 4px;
		vertical-align: middle;
	}
`

export const UploadLabel = styled.label`
	display: inline-block;
	cursor: pointer;
	input[type="text"] {
		width: 450px;
		max-width: none;
		padding-right: 40px;
	}
	div {
		max-width: none;
	}
	.ico-file {
		position: absolute;
		bottom: 8px;
		right: 10px;
	}
`

export const UploadInputWrapper = styled.div`
	position: relative;
	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		cursor: pointer;
		z-index: 10;
	}
`
